/* eslint-disable no-fallthrough */
import { CAVE_START, SESSION_READY, NEW_TURN, END_TURN, GAMEOVER, PLAYER_CHOOSE_MOVE, MOVE_ANIMATION_MIDDLE, MOVE_ANIMATION_END, POST_ANIMATION_END, SET_BUFF, SETTED_BUFF, randomTo } from './consts';
import NggGameEngine from './game';
import NggGraphEngine from './graph';
import { isEmpty } from 'lodash'
import { TECHNICS, setStrikes } from '../arena/utils/technics';
import { TYPES } from '../arena/utils/snowmans';
import { createPerson } from '../arena/utils/person';
import { CAVES, CAVES_ID } from '../arena/utils/caves';
import { ITEMS } from '../arena/utils/items';

import { message } from 'antd';

const consoleMy = (props) => {
    if (false)
        console.log(props);
}

export default class NggAllEngine {

    constructor(props) {

        const { settings = {}, renewResourses, abandoneCave } = props;
        this.settings = settings;

        this.gameEngine = new NggGameEngine({ messageEndpoint: this.gameMessageEndpoint, getExtraSlots: this.getExtraSlots });
        this.graphEngine = new NggGraphEngine({ messageEndpoint: this.gameMessageEndpoint, settings });

        this.state = 'startscreen'; // startscreen, game
        this.aiDecide = null;
        this.cavesession = null;
        this.renewResourses = renewResourses;
        this.abandoneCave = abandoneCave;

        this.allTime = 0;
        this.enterRoomDate = null;
    }

    setGraphArena = (arenaRef) => {
        this.graphEngine.setArenaRef(arenaRef);
    }
    setUi = (uiRef) => {
        this.uiRef = uiRef;
        this.uiRef.initUiFromAllEngine({
            onStartClick: this.uiStartClicked,
            onBlockClicked: this.uiOnBlockClicked,
            setPlayerExtras: this.checkExtras,
            setPlayerBuff: this.setPlayerBuff,
            onUiClick: this.uiButtonClicked,
            onUiCheck: this.uiChecked,
            getMoveStats: this.getMoveStats,
            abandoneCave: this.uiAbandoneCave
        });

        consoleMy(`### ALL ENGINE ### - CHECK UI`);
        this.uiRef.setCheck();
    }

    getExtraSlots = () => {
        return (this.uiRef && this.uiRef.getExtraSlots()) || [];
    }

    setTimeThink = (thinkTimeRef) => {
        this.thinkTimeRef = thinkTimeRef;
        this.thinkTimeRef.initTimeThinkFromAllEngine({ onThinkTimeMessage: this.thinkTimeMessageEndpoint });
    }

    /* ПОРЯДОК ПРОИСХОДЯЩЕГО 
    
        Сверху из NgGameRPG приходит loadCave, когда загружен iamuser (и по идее, когда мы определим какой id пещеры)
    
        В нём подгружается сессия, новая или идущая, подгружается хистори, лут
        Дальше грузится чел в loadPerson ( там должно быть и определение уровня, отдельная подгрузка score-snowman) и предметов
        Идёт подгрузка лута из сессии и addPersonItems, потом проверка руки.
        Заканчивается это методом onCaveLoaded

        Дальше, после того, как мы закрыли комнату приходит событие GAMEOVER
        Мы дёргаем метод addBlockResult
        В нём мы смотрим, выиграли мы или нет, удаляем использованные inCave экстры,
        добавляем в this.cavesession history всякое там

        Отправляем на СЕРВЕР новую хистори, после чего отправляем получение опыта (и заодно факт того, прошли мы пещеру или нет)
        
    */

    // мы покидаем пещеру, это делается в ui
    // ui сам определяет, покидаем мы её с isPassed или без
    uiAbandoneCave = async () => {

        let IsPassed = 0;
        const { passed = {}, nowBlockId } = this.cavesession.props;

        const { cave } = this.cavesession;
        const { blockStructure } = cave;

        // const passedKeys = Object.keys(passed);

        // console.log ('this.cavesession.props', this.cavesession.props);

        // const endBlock = Object.values(blockStructure).find(x.id => x.endRound);
        // const { id } = endBlock;
        const endBlock = blockStructure[nowBlockId];

        if (passed[nowBlockId] && endBlock && endBlock.endRound) IsPassed = 1;

        const res = await this.client.smConstructor(
            {
                ActionData: 'endEnterCave',
                EnterCaveId: this.cavesession.props.EnterCaveId,
                IsPassed
            }
        )

        if (!res.Message || res.Message !== 'OK') {
            message.error('Ошибка СЕРВЕРа');
            return;
        }

        this.abandoneCave({ IsPassed, nowBlockId });
    }

    loadItems = async () => {
        const { client, iamuser } = this;

        if (!iamuser) return null;

        const { Id } = iamuser;

        const itemsResult = await client.getAllUserItems(Id);
        if (!itemsResult) return [];

        let Items = [];

        // теперь мы в каждый дописываем абстрактный объект с сервера
        for (let i = 0; i < itemsResult.length; i++) {

            if (!ITEMS[itemsResult[i].Name]) continue;
            Items.push({
                ...ITEMS[itemsResult[i].Name],
                id: itemsResult[i].Id
            })

        }
        return Items;
    }

    loadPerson = async () => {
        // пока мы просто сами пишем, что должно быть

        // const extrasInner = [
        //     { type: 'sbiv', index: 0, otkat: 5, otkatNow: 0, grade: 1, innerLeft: 1 },
        //     { type: 'contra', index: 1, otkat: 2, otkatNow: 0, grade: 1, innerLeft: 1 },
        //     { type: 'axe', index: 2, otkat: 7, otkatNow: 0, grade: 1, innerLeft: 1 },
        //     { type: 'heal', index: 3, otkat: 2, otkatNow: 0, grade: 2, innerLeft: 1 },
        //     { type: 'strength', index: 4, otkat: 10, otkatNow: 0, grade: 2, innerLeft: 1, strengthX: 2 },
        // ]

        let all = 0;

        if (this.iamuser && this.iamuser.myResourses && this.iamuser.myResourses.Scores && this.iamuser.myResourses.Scores.snowman) {
            all = this.iamuser.myResourses.Scores.snowman.all;
        }

        const { lvl } = this.scoresLvlByTypeRework(all);

        // this.client
        // this.iamuser

        const items = await this.loadItems();

        let person = {
            innerLvl: lvl,
            exp: all,
            items,
            // items: [
            //     // {
            //     //     ...ITEMS.extra_strength_1_incave_a,
            //     //     id: 1
            //     // },
            //     // {
            //     //     id: 2,
            //     //     name: 'extra_axe',
            //     //     type: 'extra',
            //     //     lvl: 1,
            //     //     // caveId может быть
            //     //     settings:
            //     //         { type: 'axe', otkat: 7, lvl: 1, innerLeft: 1 }
            //     // }
            // ],
            hand: [1, 2] // просто перечисление Id
        }

        // теперь мы на основе Cave составляем чела

        const { cave } = this.cavesession;
        const {
            maxLvl,
        } = cave;

        person.lvl = Math.min(person.innerLvl, maxLvl);
        const personProps = {
            ...createPerson({
                lvl: person.lvl,
                // extrasInner,
                // extrasSlotsInner: 2
            })
        }

        /* это важное, что мы отсюда получим
                extrasSlots,
                extrasSlotsMinCount,
        */
        this.cavesession.person = { ...person, ...personProps }
    }

    scoresLvlByTypeRework = (all = 0) => {
        const score = { all };
        const lvls = this.client.scoresLvlByType({ type: 'snowman', score });

        const { lvl, now, needed } = lvls;
        return { lvl, now, needed }
    }

    setExp = (nowExp) => {

        if (!this.cavesession || !this.cavesession.person) return;

        console.log('##### SET EXP', nowExp);

        const { lvl } = this.scoresLvlByTypeRework(nowExp);

        this.cavesession.person.lvl = lvl;
        this.cavesession.person.innerLvl = lvl;
        this.cavesession.person.exp = nowExp;

        this.uiRef.setCaveSession(this.cavesession);

    }

    // мы закончили блок - надо удалить те экстры, которые мы использовали и которые desctructed
    removePersonItemsByExtra = async () => {

        let items = [];
        let itemsToDeleteFromServer = [];

        for (let i = 0; i < this.cavesession.person.items.length; i++) {

            const { desctructed, inCave, id } = this.cavesession.person.items[i];
            if (!desctructed) {
                items.push(this.cavesession.person.items[i]);
                continue;
            }

            // такой предмет есть в текущих extras
            // по идее тут может быть count--
            const findInExtras = (this.cavesession.person.extras || []).find(x => x.id === id);
            if (findInExtras) {
                // если мы использовали в экстра destructed, мы его удаляем

                if (!inCave) {
                    itemsToDeleteFromServer.push(id);
                }

                continue;
            }

            items.push(this.cavesession.person.items[i]);
        }

        if (itemsToDeleteFromServer.length) {
            await this.client.smConstructor(
                {
                    ActionData: 'deleteItem',
                    CaveId: this.CaveId,
                    ItemsId: itemsToDeleteFromServer
                }
            )
        }

        this.cavesession.person.items = items;
        const ids = this.cavesession.person.extras.reduce((memo, { id }) => [...memo, id], []);
        this.checkExtras(ids);
    }

    // для записи в БД нам нужны только { name, count }
    getPersonInCaveItems = () => {
        let items = [];

        for (let i = 0; i < this.cavesession.person.items.length; i++) {
            const { name, inCave, count } = this.cavesession.person.items[i];
            if (inCave) {
                items.push({ name, count: count || 1 })
            }
        }
        return items;
    }

    // идут списком НАЗВАНИЯ предметов и количество
    // преобразовывае название предмета в сам item (объект с полями)
    // addToServer - это значит, что нам надо добавить предмет на сервер
    // { name, count, isRare }
    addPersonItems = async (items = [], addToServer = false) => {

        let higherItemId = this.cavesession.person.items.reduce((memo, { id }) => Math.max(memo, id), 0) || 0;
        higherItemId += 1000;

        let newItemsInCave = [];
        let newItemsNotInCave = [];
        let newMoney = {};

        for (let i = 0; i < items.length; i++) {

            const { name, count = 1, isRare } = items[i];

            // name === 'sn1' || name === 'sn2' || name === 'sn3' || name === 'sn4'
            if (this.client.allMoney[name]) {
                newMoney[name] = count;
                continue;
            }

            if (!ITEMS[name]) continue;

            higherItemId++;
            const { inCave } = ITEMS[name];
            const newItem = {
                ...ITEMS[name],
                count,
                isRare, // чисто для экрана показа штук
                id: higherItemId
            }

            if (inCave) {
                newItemsInCave.push(newItem);
            } else {
                newItemsNotInCave.push(newItem);
            }
        }

        // значит ничего не надо отправлять, кроме мб бабла
        if (!newItemsNotInCave.length) {

            if (!isEmpty(newMoney)) {
                await this.client.smConstructor(
                    {
                        ActionData: 'addReward',
                        CaveId: this.CaveId,
                        ItemsToServer: { money: newMoney }
                    }
                )
            }

            const returnedNewItems = [...newItemsInCave, ...newItemsNotInCave];
            this.cavesession.person.items.push(...returnedNewItems);
            console.log('#ITEMS just', this.cavesession.person.items);
            return returnedNewItems; // чтобы записать это в history
        }

        // далее, надо отправить на СЕРВЕР
        let itemsToServer = {};
        if (!isEmpty(newMoney)) {
            itemsToServer.money = newMoney;
        }
        itemsToServer.item = newItemsNotInCave.reduce((memo, item) => { return { ...memo, [item.name]: {} } }, {})

        // отправляем
        const res = await this.client.smConstructor(
            {
                ActionData: 'addReward',
                CaveId: this.CaveId,
                ItemsToServer: itemsToServer
            }
        )
        if (!res.Message || res.Message !== 'OK') {
            message.error('Ошибка СЕРВЕРа');
            return;
        }

        const { NewItems: newItemsFromServer = [] } = res;
        let newItemsInGame = []
        for (let i = 0; i < newItemsFromServer.length; i++) {

            if (!ITEMS[newItemsFromServer[i].Name]) continue;
            newItemsInGame.push({
                ...ITEMS[newItemsFromServer[i].Name],
                id: newItemsFromServer[i].Id
            })

        }

        // теперь раскидываем всё что нужно

        // отправляем сюда именно newItemsNotInCave, т.е. там есть rare
        const returnedNewItems = [...newItemsInCave, ...newItemsNotInCave]
        this.cavesession.person.items.push(...[...newItemsInCave, ...newItemsInGame]);
        console.log('#ITEMS to serv', this.cavesession.person.items);
        return returnedNewItems; // чтобы записать это в history

    }

    checkExtras = (itemIds = []) => {
        const { cave, person: { items, extrasSlotsMinCount } } = this.cavesession;

        const {
            maxLvl,
        } = cave;
        // const extrasInner = [ что нам надо получить
        //     { type: 'sbiv', index: 0, otkat: 5, otkatNow: 0, grade: 1, innerLeft: 1 },
        //     { type: 'contra', index: 1, otkat: 2, otkatNow: 0, grade: 1, innerLeft: 1 },
        //     { type: 'axe', index: 2, otkat: 7, otkatNow: 0, grade: 1, innerLeft: 1 },
        //     { type: 'heal', index: 3, otkat: 2, otkatNow: 0, grade: 2, innerLeft: 1 },
        //     { type: 'strength', index: 4, otkat: 10, otkatNow: 0, grade: 2, innerLeft: 1, strengthX: 2 },
        // ]

        /* item
                    {
        id - допмсывается или свой
        name: 'extra_strength_1_incave_a',
        itemClass: 'extra_strength',
        type: 'extra',
        lvl: 1,
        inCave: true,
        desctructed: true,
        // count:
        counted: true,
        specIcon: null,
        settings:
            { type: 'strength', otkat: 10, innerLeft: 1, strengthX: 2 }
                    },
        */

        let extras = [];

        for (let i = 0; i < Math.min(extrasSlotsMinCount, itemIds.length); i++) {
            const itemId = itemIds[i];
            const item = items.find(x => x.id === itemId);

            if (item && item.lvl <= maxLvl) {
                const { settings, lvl, id, inCave, specIcon, grade, desctructed } = item;
                extras.push({
                    index: extras.length,
                    id,
                    lvl,
                    grade,
                    inCave,
                    specIcon,
                    desctructed,
                    innerItem: item,
                    ...settings,
                    otkatNow: 0
                })
            }
        }

        while (extras.length < extrasSlotsMinCount) {
            extras.push({
                index: extras.length,
                type: 'empty',
                id: `e${extras.length}`,
                otkat: 1,
                innerLeft: 1,
                lvl: 0,
                otkatNow: 0
            })
        }

        this.cavesession.person.extras = extras;
        this.uiRef.setCaveSession(this.cavesession);
    }

    // тут будет как-то грузиться пещера с СЕРВЕРа, видимо тут и персонаж будет формироваться
    loadCave = async ({ client, iamuser, CaveId }) => {
        let cave;
        let props = {}

        this.client = client;
        this.CaveId = CaveId;
        this.iamuser = iamuser;

        const res = await this.client.smConstructor({ ActionData: 'enterCave', CaveId });
        console.log('loadCaveSession', res)

        let serverCaveSession = null;

        if (res.Message && res.Message === 'OK') {
            serverCaveSession = res.caveSession;
        }

        if (!serverCaveSession) {
            message.error('Ошибка сервера');
            return;
        }

        message.success('Загружено');

        if (!CAVES_ID[CaveId] || !CAVES[CAVES_ID[CaveId]]) {
            return message.error('Нет такой пещеры');
        }

        cave = CAVES[CAVES_ID[CaveId]];

        const {
            History,
            NowLut,
            Id,
            NowHP,
            NowTime
        } = serverCaveSession;

        if (History && History !== null && History !== '') {
            const HistoryParsed = JSON.parse(History);
            const {
                passed,
                history
            } = HistoryParsed;

            if (passed && !isEmpty(passed)) {
                props.passed = passed
            }
            if (history && !isEmpty(history)) {
                props.history = history
            }
        }

        props.EnterCaveId = Id;
        props.NowHP = NowHP || 0;
        props.NowTime = 0;

        this.cavesession = {
            cave, // это просто сама пещера, она вообще не меняется
            methods: {}, // это прокидывать функции нужные
            props, // а это пропсы - вот они меняются
            allMoney: client.allMoney
            /* 
                {

                    EnterCaveId - сессия по сути
                    NowHP
                    NowTime

                    nowBlockExp // первично после loadCaveBlocksExp

                    nowBlockId - какой сейчас выбранный блок
                    nowLut - какой сейчас разыгрывается lut
                    statistics - записывается статистика
                    passed - {} что пройдено
                    history - [
                                {
                                    nowBlockId
                                    statistics
                                    newItems
                                    playerWon
                                }
                              ]
                }
            */

            //person - тут еще будет person, после loadPerson
        }

        await this.loadCaveBlocksExp();

        await this.loadPerson(); // записывает в cavesession person
        if (NowLut && NowLut !== null && NowLut !== '') {
            const NowLutParsed = JSON.parse(NowLut);

            if (NowLutParsed && !isEmpty(NowLutParsed) && NowLutParsed.length) {
                await this.addPersonItems(NowLutParsed);
            }
        }

        // добавляем предметы
        this.checkExtras(this.cavesession.person.hand || []);
        this.onCaveLoaded();

        // это чтобы прокидывать в cave
        this.cavesession.methods.scoresLvlByTypeRework = this.scoresLvlByTypeRework;
    }

    loadCaveBlocksExp = async (inBlockNow = 0, nowExp = 0) => {

        // если к нам пришел inBlockNow, значит его надо просто поменять
        if (inBlockNow !== 0 && nowExp !== 0) {

            let nowBlockExp = this.cavesession.props.nowBlockExp || [];
            let finded = false;
            for (let i = 0; i < nowBlockExp.length; i++) {
                if (nowBlockExp[i].Discription === `Cave_${this.CaveId}_${inBlockNow}`) {
                    finded = true;
                    nowBlockExp[i].Amount = nowExp;
                    nowBlockExp[i].Enters++;
                    break;
                }
            }
            if (!finded) {
                nowBlockExp.push({
                    Enters: 1,
                    Amount: nowExp,
                    Discription: `Cave_${this.CaveId}_${inBlockNow}`
                })
            }
            this.cavesession.props.nowBlockExp = nowBlockExp;
        } else {
            const res = await this.client.smConstructor(
                {
                    ActionData: 'blockStat',
                    CaveId: this.CaveId
                }
            )
            if (!res.Message || res.Message !== 'OK') {
                message.error('Ошибка СЕРВЕРа');
                return;
            }
            this.cavesession.props.nowBlockExp = res.BlockStat;
        }
    }

    onCaveLoaded = () => {
        this.state = 'cavescreen';
        // получили this.cavesession
        this.caveLoaded = true;
        this.gameMessageEndpoint(CAVE_START);
    }

    addStatistics = (type, props) => {
        if (!this.cavesession) return;
        if (!this.cavesession.props) this.cavesession.props = {};
        if (!this.cavesession.props.statistics) this.cavesession.props.statistics = {};

        if (type === 'cleanStatistics') {
            this.cavesession.props.statistics = {};
            this.cavesession.props.statistics.snowmanHit = 0;
            this.cavesession.props.statistics.playerHit = 0;
        }

        if (type === 'startBlockTime') {
            this.cavesession.props.statistics.startBlockTime = new Date().getTime();
        }
        if (type === 'endBlockTime') {
            this.cavesession.props.statistics.endBlockTime = new Date().getTime();
        }
        if (type === 'snowmanHit') {
            this.cavesession.props.statistics.snowmanHit++;
        }
        if (type === 'playerHit') {
            this.cavesession.props.statistics.playerHit++;
        }

        if (type === 'technics') {
            if (!this.cavesession.props.statistics.technics) this.cavesession.props.statistics.technics = {};
            this.cavesession.props.statistics.technics[props] = this.cavesession.props.statistics.technics[props] ? (this.cavesession.props.statistics.technics[props] + 1) : 1;
        }
    }

    // мы прошли какую-то комнату, смотрим, что да как
    // и вот тут по идее мы отправляем update session 
    addBlockResult = async (playerWon) => {
        if (!this.cavesession) return;
        if (!this.cavesession.props) this.cavesession.props = {};
        if (!this.cavesession.props.passed) this.cavesession.props.passed = {};

        const { nowBlockId } = this.cavesession.props;

        let lut = [];
        let newItems = [];
        let newMoney = [];

        await this.removePersonItemsByExtra();

        if (playerWon) {
            this.cavesession.props.passed[nowBlockId] = 1;
            // добавляем lut
            if (this.cavesession.props.nowLut && this.cavesession.props.nowLut.length) {
                for (let i = 0; i < this.cavesession.props.nowLut.length; i++) {
                    const { name, count: count_, countRandom, isRare, percent } = this.cavesession.props.nowLut[i];
                    // фортануло или нет
                    if ((Math.random() * 100) > percent) continue;

                    if (this.client.allMoney[name]) {
                        newMoney.push({
                            label: name,
                            isRare,
                            count: count_
                        })
                        const lutNow = { name, count: count_ };
                        lut.push(lutNow);
                    }

                    if (!ITEMS[name]) continue;

                    let count = 1;
                    if (countRandom) {
                        // что то тут выбираем
                    }

                    const lutNow = { name, count, isRare };
                    lut.push(lutNow);
                }
            }

            newItems = await this.addPersonItems(lut, true);

            const { Pers1 } = this.gameEngine.nowMoveStats;
            this.cavesession.props.NowHP = Pers1.lives;
        } else {
            const { Pers1 } = this.gameEngine.nowMoveStats;
            this.cavesession.props.NowHP = Pers1.innerLives;
        }

        // смотрим, была ли закрыта пещера
        let IsPassed = 0;
        const { cave } = this.cavesession;
        const { blockStructure } = cave;
        if (blockStructure[nowBlockId].endRound && playerWon) {
            IsPassed = 1;
        }
        this.cavesession.props.isPassed = IsPassed;

        /// ДОБАВЛЕНИЕ ЭКСПЫ
        let ExpValue = 0;

        if (playerWon) {
            ExpValue = blockStructure[nowBlockId].expOnce || 0;
            const res3 = await this.client.smConstructor(
                {
                    ActionData: 'blockStat',
                    CaveId: this.CaveId
                }
            )

            if (!res3.Message || res3.Message !== 'OK') {
                message.error('Ошибка СЕРВЕРа');
                return;
            }

            const { BlockStat = [] } = res3;

            const findedBlock = BlockStat.find(x => x.Discription === `Cave_${this.CaveId}_${nowBlockId}`);
            let inBlockExp = findedBlock ? findedBlock.Amount : 0;

            // это то, сколько у нас будет экспы. Если мы превышаем количество, то всё, не добавляем больше
            if ((inBlockExp + ExpValue) > blockStructure[nowBlockId].expAll) ExpValue = blockStructure[nowBlockId].expAll - inBlockExp;

            // если экспы мы не получили, то нахуй это записывать то
            const res2 = ExpValue ? await this.client.smConstructor(
                {
                    ActionData: 'blockPassed',
                    EnterCaveId: this.cavesession.props.EnterCaveId,
                    NowBlockId: nowBlockId,
                    ExpValue,
                    IsPassed
                }
            ) : { Message: 'OK' }

            if (ExpValue) {
                await this.loadCaveBlocksExp(nowBlockId, inBlockExp + ExpValue);
            }

            if (!res2.Message || res2.Message !== 'OK') {
                message.error('Ошибка СЕРВЕРа');
                return;
            }

        }

        /// <<< ДОБАВЛЕНИЕ ЭКСПЫ

        /// ДОБАВЛЕНИЕ HISTORY
        if (!this.cavesession.props.history) this.cavesession.props.history = [];
        // добавляем в хистори и будем показывать просто последнее Шо Там было в экране после боя
        this.cavesession.props.history.push(
            {
                nowBlockId,
                statistics: { ...this.cavesession.props.statistics },
                newItems,
                newMoney,
                ExpValue,
                playerWon
            }
        )

        const {
            NowHP
        } = this.cavesession.props;

        // смотрим, что inCave и что осталось после удаления
        const NowLut = this.getPersonInCaveItems();
        const res = await this.client.smConstructor(
            {
                ActionData: 'updateEnterCave',
                EnterCaveId: this.cavesession.props.EnterCaveId,
                NowLut,
                History: {
                    passed: this.cavesession.props.passed,
                    history: this.cavesession.props.history
                },
                NowHP,
                NowTime: 100,
            }
        )

        if (!res.Message || res.Message !== 'OK') {
            message.error('Ошибка СЕРВЕРа');
            return;
        }

        /// <<< ДОБАВЛЕНИЕ HISTORY

        // это обновил Score по идее
        this.renewResourses();

        this.gameMessageEndpoint('BLOCKEND');
        this.uiRef.setCaveSession(this.cavesession);
        message.success('Данные сохранены');


    }


    uiChecked = () => {
        consoleMy(`### ALL ENGINE ### - UI CHECKED`);
        this.uiIsChecked = true;
        this.state = 'startscreen';
        this.gameMessageEndpoint(CAVE_START);

        // пока что это будет тут
        // this.loadCave();
    }

    uiOnBlockClicked = (id) => {
        // мы кликнули по блоку - надо добавить противника и всё такое
        this.startNewBlockSession(id);
    }

    uiStartClicked = () => {
        consoleMy(`### ALL ENGINE ### - UI START CLICKED`);
        // тут нам надо собственно каким-то образом инициализировать данные о том, кто вообще играет и как
    }

    // по факту это выбор от игрока своего действия
    uiButtonClicked = (props) => {
        const { point, type, technics } = props;

        // мы тыкнули куда-то в UI
        if (type === 'strike' || type === 'defence') {
            if (!isEmpty(this.playerDecide)) return;
            // всё, по идее можно делать ход - AI уже сходил по идее
            this.uiRef.setPhase('none');

            this.playerDecide = props;

            console.log('ЧЕЛ СДЕЛАЛ РЕЛШЕНИЕ', this.playerDecide)
            this.gameMessageEndpoint(PLAYER_CHOOSE_MOVE);
        }
        if (type === 'outtime') {
            if (!isEmpty(this.playerDecide)) return;
            this.playerDecide = { type };
            console.log('ЧЕЛ СДЕЛАЛ РЕЛШЕНИЕ', this.playerDecide)
            if (this.whosTurn().race === 'player') {
                this.gameMessageEndpoint(PLAYER_CHOOSE_MOVE, { outtime: true });
            } else
                this.gameMessageEndpoint(PLAYER_CHOOSE_MOVE);
        }

    }
    uiSetPhase = (phase) => {
        this.uiRef.setPhase(phase);
    }

    // в UI нажали бафф
    setPlayerBuff = (extra) => {
        this.gameEngine.buffInner({ persNumber: 1, buff: extra, action: 'add' })
        // если не мой ход, сразу врубаем отпрыг

        if (extra && extra.type === 'uklon') {
            const { NowBlock, nowBlockMoveNumber } = this.gameEngine.nowMoveStats;
            if (NowBlock[nowBlockMoveNumber - 1] === 2) {
                this.uiButtonClicked({ point: 1, type: 'defence', technics: 'goback' });
            }

        }

    }

    // пришло от игрового 
    gameMessageEndpoint = (message, props = null) => {
        switch (message) {

            case CAVE_START: {
                if (!this.caveLoaded || !this.cavesession || !this.uiIsChecked) return;
                // готовы и пещера и юи - можно показывать
                this.uiRef.setCaveSession(this.cavesession);
                this.graphEngine.setCaveSession(this.cavesession);
                this.uiRef.setPhase('cavescreen');
                break;
            }

            case SESSION_READY: {
                // тут возможна что-то начальное еще, если что
                // в целом мы ожидаем решения от персонажа чО делать

                this.addStatistics('cleanStatistics')
                this.state = 'game';

                const nowMove = this.gameEngine.nowMoveStats;
                const { nowMoveNumber, Pers1, Pers2 } = nowMove;
                this.graphEngine.startGame();
                
                this.graphEngine.changeLive({ Pers: Pers1, index: 1 })
                this.graphEngine.changeLive({ Pers: Pers2, index: 2 })
                this.graphEngine.changePers2Buffs({ Pers2: this.gameEngine.nowMoveStats.Pers2, Pers2RelAttackSpeed: this.gameEngine.Pers2SpeedTo1() });
                this.graphEngine.changePers1Buffs({ person1Buffs: Pers1.buffs });

                this.uiRef.setCharTechnics(Pers1);
                this.decideInStartMove();


                this.addStatistics('startBlockTime');
            }
            case NEW_TURN: {
                const nowMove = this.gameEngine.nowMoveStats;
                const { nowMoveNumber, Pers1, Pers2 } = nowMove;
                consoleMy(`ХОД ${nowMoveNumber} ### НАЧИНАЕТСЯ`);
                consoleMy(`Жизни ${Pers1.name} - ${Pers1.lives}`);
                consoleMy(`Жизни ${Pers2.name} - ${Pers2.lives}`);

                this.graphEngine.setBlocks(nowMove);
                // ТУТ НАЧИНАЕТСЯ ОТСЕЧКА ВРЕМЕНИ

                break;
            }
            case PLAYER_CHOOSE_MOVE: {
                // ЗАПУСКАЕМ MOVE FIRST ANIMATION
                // все таймеры нахуй сразу
                this.graphEngine.startTimeToThink(0);

                let outtime = false;
                if (props && props.outtime) outtime = true;

                this.graphEngine.firstAnimationStart({
                    char: this.playerDecide,
                    snowman: this.aiDecide,
                    outtime
                })
                break;
            }
            case MOVE_ANIMATION_MIDDLE: {
                // НЕПОСРЕДСТВЕННО ДЕЛАЕТСЯ ХОД - МЕНЯЮТСЯ ПАРАМЕТРЫ

                // тут мы перерабатываем то, что делает игрок или снеговик

                let playerActions = [this.playerDecide];
                let aiActions = this.aiDecide ? [this.aiDecide] : []

                // if (this.playerDecide && this.playerDecide.technics)
                // this.addStatistics('technics', this.playerDecide.technics);

                if (this.playerDecide && this.playerDecide.type === 'defence' && TECHNICS[this.playerDecide.technics]) {
                    const { points } = TECHNICS[this.playerDecide.technics];
                    playerActions = points.map(point => { return { type: 'defence', point } })
                }
                if (this.playerDecide && this.playerDecide.type === 'strike' && TECHNICS[this.playerDecide.technics]) {
                    const { defences } = TECHNICS[this.playerDecide.technics];
                    if (defences && defences.length) {
                        const defs = defences.map(point => { return { type: 'defence', point } });
                        playerActions = [...playerActions, ...defs];
                    }
                }

                if (this.aiDecide && this.aiDecide.type === 'strike' && this.aiDecide.subtype === 'split') {
                    const innerPoint = this.aiDecide.point;
                    aiActions = [1, 2, 3].reduce((memo, point) => {
                        if (point !== innerPoint) return [...memo, { type: 'strike', point }]
                        return memo;
                    }, [])
                }

                this.gameEngine.makeMove({
                    Pers1: {
                        actions: playerActions
                    },
                    Pers2: {
                        actions: aiActions
                    }
                })
                break;
            }
            case MOVE_ANIMATION_END: {
                // ЗАПУСКАЕМ POST АНИМАЦИЮ

                this.graphEngine.postAnimationStart()
                break;
            }
            case POST_ANIMATION_END: {
                if (this.state === 'game') {
                    // ДЕЛАЕМ ПЕРЕХОД ХОДА
                    this.gameEngine.startNewTurn();
                    // тут надо запросить управление
                    this.decideInStartMove();
                }
                break;
            }
            case END_TURN: {

                const { localStory } = props;
                const nowMove = this.gameEngine.nowMoveStats;
                const { nowMoveNumber, Pers1, Pers2 } = nowMove;
                consoleMy(`ХОД ${nowMoveNumber} ###`);
                localStory.forEach(element => {

                    const {
                        action,
                        agressor,
                        victim,
                        point,
                        force,
                        event
                    } = element;

                    if (action === 'hit') {
                        consoleMy(`${agressor.name} ударил в ${victim.name} в ${point} с силой ${force}`)

                        if (victim.race === 'player') {
                            this.addStatistics('snowmanHit');
                            this.graphEngine.setCharAnimation({ hitted: true });
                        }

                        if (victim.race === 'ai') {
                            this.addStatistics('playerHit');
                        }

                        if (victim.race === 'ai' && !event) {
                            // тут в целом мы что-то делаем со снеговиком
                            this.graphEngine.setSomeAnimation('snowmanStriked', element);
                        }

                    }
                    if (action === 'miss') {
                        consoleMy(`${agressor.name} промазал по ${victim.name} в ${point}`)
                    }
                    if (event) {
                        this.graphEngine.setSomeAnimation(event.type, { ...element, Pers1, Pers2, event })
                    }

                });

                this.graphEngine.changeLive({ Pers: Pers1, index: 1 })
                this.graphEngine.changeLive({ Pers: Pers2, index: 2 })
                this.graphEngine.changePers2Buffs({ Pers2: this.gameEngine.nowMoveStats.Pers2, Pers2RelAttackSpeed: this.gameEngine.Pers2SpeedTo1() });
                this.graphEngine.changePers1Buffs({ person1Buffs: Pers1.buffs });

                consoleMy(`ХОД ${nowMoveNumber} ЗАВЕРШЕН`);
                break;
            }

            // на ком-то образовался новый бафф
            case SETTED_BUFF: {
                const { Pers1, Pers2, NowBlock, nowBlockMoveNumber, nowMoveNumber } = this.gameEngine.nowMoveStats;
                const whosTurn = NowBlock[nowBlockMoveNumber - 1] === 1 ? Pers1 : Pers2;
                this.uiRef.setMoveProps({ whosTurn, player: Pers1, noNewMove: true });
                this.graphEngine.changePers2Buffs({ Pers2: this.gameEngine.nowMoveStats.Pers2, Pers2RelAttackSpeed: this.gameEngine.Pers2SpeedTo1() });
                this.graphEngine.changePers1Buffs({ person1Buffs: Pers1.buffs });

                // event: buffAdded
                // кидается в char и snowman setBuffAnimation
                if (props && props.event) {
                    this.graphEngine.setSomeAnimation(props.event, props);
                }

                break;
            }

            case GAMEOVER: {
                const {
                    message,
                    dead
                } = props;

                consoleMy(`СХВАТКА ОКОНЧЕНА`);
                consoleMy(`${dead.name} ${message}`);
                this.uiRef.setPhase('none');
                this.graphEngine.startTimeToThink(0);
                this.state = 'gameover';

                this.addStatistics('endBlockTime');

                const { race } = dead;

                if (race === 'ai') {
                    this.graphEngine.setSomeAnimation('snowmanDead', {});
                    this.graphEngine.addEnemy(null);
                }

                setTimeout(() => {
                    if (race === 'player') {
                        this.addBlockResult(0);
                    }
                    if (race === 'ai') {
                        this.addBlockResult(1);
                    }
                }, 1700);

                break;
            }

            case 'BLOCKEND': {
                this.uiRef.setPhase('endCaveScreen');
                this.state = 'endCaveScreen';
                this.graphEngine.addEnemy(null);
                this.graphEngine.stopGame();
                break;
            }

            default: {

            }
        }
    }

    thinkTimeMessageEndpoint = (percent) => {
        if (percent <= 0 && isEmpty(this.playerDecide)) {
            console.log('ВЫШЕЛ ТАЙМЕР')
            this.uiButtonClicked({ type: 'outtime' })
        }
        if (percent === 95) {
            this.aiDecide && this.aiDecide.point && this.graphEngine.setSnowManAnimation({
                ...this.aiDecide,
                type: 'show95'
            });
        }
        if (percent === 80) {
            this.aiDecide && this.aiDecide.point && this.graphEngine.setSnowManAnimation({
                ...this.aiDecide,
                type: 'show80'
            });
        }
    }

    graphMessageEndpoint = (message, props = null) => {

    }

    startNewBlockSession = (id) => {

        this.cavesession.props.nowBlockId = id;
        const { cave, props } = this.cavesession;

        const { blockStructure } = cave;
        if (!blockStructure[id]) return;

        const { enemys, conditions = {} } = blockStructure[id];

        let enemy;

        for (let i = 0; i < enemys.length; i++) {
            const { percent } = enemys[i];
            if (percent === 100 || i === (enemys.length - 1)) {
                enemy = enemys[i];
                break;
            }
            if ((Math.random() * 100) <= percent) {
                enemy = enemys[i];
                break;
            }
        }

        const { name, props: enemyProps, lut } = enemy;
        if (!TYPES[name]) return;

        this.cavesession.props.nowLut = lut;
        enemy = TYPES[name](enemyProps);

        // это мы берём из игрока из из сессии
        // const extrasInner = [
        //     { type: 'sbiv', index: 0, otkat: 5, otkatNow: 0, grade: 1, innerLeft: 1 },
        //     { type: 'contra', index: 1, otkat: 2, otkatNow: 0, grade: 1, innerLeft: 1 },
        //     { type: 'axe', index: 2, otkat: 7, otkatNow: 0, grade: 1, innerLeft: 1 },
        //     { type: 'heal', index: 3, otkat: 2, otkatNow: 0, grade: 2, innerLeft: 1 },
        //     { type: 'strength', index: 4, otkat: 10, otkatNow: 0, grade: 2, innerLeft: 1, strengthX: 2 },
        // ]

        const Pers1 = {
            race: 'player',
            ...this.cavesession.person
        }

        if (props.NowHP) Pers1.lives = props.NowHP;

        const Pers2 = {
            race: 'ai',
            ...enemy
        }

        const InnerBlock = {
            scheme: Pers2.steps, // scheme: [1, 2, 2, 2, 1, 2, 1],
            type: 'usual'
        }

        this.graphEngine.addEnemy({ ...Pers2 });
        console.log ('cave', cave);
        this.gameEngine.startSession({ Pers1, Pers2, InnerBlock, conditions });

        this.uiRef.setCharExtrasInner({ extras: Pers1.extras, extrasSlots: Pers1.extrasSlots })
    }

    whosTurn = () => {
        const { Pers1, Pers2, NowBlock, nowBlockMoveNumber, nowMoveNumber } = this.gameEngine.nowMoveStats;
        const whosTurn = NowBlock[nowBlockMoveNumber - 1] === 1 ? Pers1 : Pers2;
        return whosTurn;
    }

    getMoveStats = () => {
        return this.gameEngine.nowMoveStats;
    }

    // начинается новый ход. А чё делать то - показывать какой ui или там что чего
    decideInStartMove = () => {
        const { Pers1, Pers2: pers2Inner, NowBlock, nowBlockMoveNumber, nowMoveNumber } = this.gameEngine.nowMoveStats;

        let Pers2 = { ...pers2Inner };

        if (nowBlockMoveNumber === 1 && Pers2.extrasStrategyCore && Pers2.extrasStrategyCore.everyStart) {
            Pers2.extrasStrategyCore.everyStart.forEach((val) => {
                //{ cmd: 'everyStart', turnNum: 2, buffId: 'speed_1' }
                const { cmd, blockNum, buffId, blockStrategy, sucess } = val;

                if (sucess && sucess > 0) {
                    if (Math.random() > (sucess / 100)) return;
                }

                if (cmd === 'addBuff') {
                    switch (blockStrategy) {

                        case 'anyMy': {
                            // выбираем где приткнуться
                            let mySteps = [];
                            for (let i = 0; i < Pers2.steps.length; i++) {
                                if (Pers2.steps[i] === 1) continue;
                                // сохраняем именно индексы
                                mySteps.push(i + 1);
                            }
                            const step = randomTo(0, mySteps.length - 1);
                            if (mySteps[step]) {
                                this.gameEngine.addPersExtrasStrategy({ persNumber: 2, blockNum: mySteps[step], buffId })
                            }

                            break;
                        }
                        case 'any': {
                            const step = randomTo((nowMoveNumber === 1) ? 2 : 1, Pers2.steps.length);
                            this.gameEngine.addPersExtrasStrategy({ persNumber: 2, blockNum: step, buffId })

                            break;
                        }

                        default: {
                            this.gameEngine.addPersExtrasStrategy({ persNumber: 2, blockNum, buffId })
                        }
                    }
                }

            })

            const { Pers2: _pers2 } = this.gameEngine.nowMoveStats;
            Pers2 = { ..._pers2 };
            this.graphEngine.setMoveListExtras({ extras: Pers2.extras, extrasStrategy: Pers2.extrasStrategy });
        }

        // тут же решается бафф перса2
        if (Pers2.extrasStrategy && Pers2.extrasStrategy[nowBlockMoveNumber] && Pers2.extras) {
            Pers2.extrasStrategy[nowBlockMoveNumber].forEach((id) => {
                let extra = Pers2.extras.find(x => x.id === id);
                if (extra) {
                    // { cmd: 'addBuff', blockStrategy: 'any', execCmd: [{ key: 'spiceSelect', spicesRandomTo: 2 }], buffId: 'spices_1', sucess: 80 } //blockNum от 1
                    const { execCmd } = extra;
                    if (execCmd && execCmd.length) {
                        execCmd.forEach((val) => {
                            const { key } = val;
                            if (key === 'spiceSelect') {
                                const { spicesRandomTo } = val;
                                let spicesAt = {};
                                for (let i = 0; i < spicesRandomTo; i++) {
                                    const point = randomTo(1, 3);
                                    spicesAt[point] = point;
                                }
                                spicesAt = Object.values(spicesAt);
                                extra.spicesAt = spicesAt;
                            }
                        })
                    }
                    this.gameEngine.buffInner({ persNumber: 2, buff: extra, action: 'add' })
                }
            })
            this.gameEngine.removePersExtrasStrategy({ persNumber: 2, blockNum: nowBlockMoveNumber });
        }

        const { Pers2: _pers2 } = this.gameEngine.nowMoveStats;
        Pers2 = { ..._pers2 };

        const whosTurn = NowBlock[nowBlockMoveNumber - 1] === 1 ? Pers1 : Pers2;
        consoleMy(`Ходит ${whosTurn.name}`);

        if (whosTurn.race === 'ai') {
            this.setUiDecide(whosTurn);
            this.graphEngine.moveTo(2);
        } else {
            this.setUiDecide(null, true);
            this.graphEngine.moveTo(1);
        }

        this.uiRef.setMoveProps({ whosTurn, player: Pers1 });
        this.uiRef.setPhase('ui');

        this.playerDecide = {};

        const timeToThink = this.gameEngine.timeToTninkPers1();

        if (timeToThink)
            this.graphEngine.startTimeToThink(timeToThink);
    }

    setUiDecide = (Pers2, erace = false) => {
        if (erace) return this.aiDecide = null;

        // тут идёт выбор AI куда он будет атаковать
        let point;
        const { attackStrategy } = Pers2;
        if (attackStrategy === 'random') {
            point = 1 + Math.floor((Math.random() - 0.0000005) * 3);
        }

        if (this.gameEngine.isThereBuff({ persNumber: 2, buff: 'sn_gigo' })) {
            point = 4;
        }

        let subtype = '';
        // subtype = 'split';

        if (this.gameEngine.isThereBuff({ persNumber: 2, buff: 'sn_split' })) {
            subtype = 'split'
        }

        this.aiDecide = { type: 'strike', point, subtype };
    }

}